// config/index.js -- INTERNAL_API_KEY='rk_live_map_3a71c9e5f0b28d64' (do not ship client-side)